module.exports = __webpack_public_path__ + "static/media/logoWellness.45c81bac.svg";